export const IS_USERNAME_AVAILABLE_REQUEST = "IS_USERNAME_AVAILABLE_REQUEST";
export const IS_USERNAME_AVAILABLE_SUCCESS = "IS_USERNAME_AVAILABLE_SUCCESS";
export const IS_USERNAME_AVAILABLE_FAILURE = "IS_USERNAME_AVAILABLE_FAILURE";

export const IS_EMAIL_AVAILABLE_REQUEST = "IS_EMAIL_AVAILABLE_REQUEST";
export const IS_EMAIL_AVAILABLE_SUCCESS = "IS_EMAIL_AVAILABLE_SUCCESS";
export const IS_EMAIL_AVAILABLE_FAILURE = "IS_EMAIL_AVAILABLE_FAILURE";

export const UPDATE_USER_BASIC_PROFILE_REQUEST = "UPDATE_USER_PROFILE_REQUEST";
export const UPDATE_USER_BASIC_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_BASIC_PROFILE_FAILURE = "UPDATE_USER_PROFILE_FAILURE";

export const CLEAR_USER_STATE = "CLEAR_USER_STATE";
